// Shared human-readable labels for Ad fields that appear on more than one
// surface (ProductAds tile/modal, Ads gallery grid + detail modal) — kept
// in one place so wording can't quietly drift between those surfaces the
// way raw field projections have drifted before between routes/ads.js and
// routes/catalog.js on the backend.

export type FunnelStage = 'awareness' | 'consideration' | 'conversion';

const FUNNEL_STAGE_LABELS: Record<FunnelStage, string> = {
  awareness:     'Awareness',
  consideration: 'Consideration',
  conversion:    'Conversion'
};

// null/undefined/any unrecognized value all return null. The caller MUST
// render nothing in that case — no "undefined" text, no orphan "·"
// separator. funnelStage is absent on most static ads and on any video ad
// that predates the funnel-stage retitle feature (models/Ad.js); that
// absence is not the same as "awareness" from the UI's point of view, even
// though the render pipeline treats an unstaged master that way internally
// (see the field's own doc comment on the model).
export function funnelStageLabel(stage: string | null | undefined): string | null {
  if (!stage) return null;
  return FUNNEL_STAGE_LABELS[stage as FunnelStage] || null;
}

// kind is always present on an Ad — no null case to hide.
export function mediaTypeLabel(kind: string | null | undefined): string {
  return kind === 'video' ? 'Video' : 'Image';
}
